import { Link, useHistory } from "react-router-dom";
import ContactCta from "../../Components/ContactCta";
import { FaGasPump, FaCogs, FaUsers, FaUserTie } from "react-icons/fa";
import { PREV_IMG } from "../../constants/endPoints";
import { convertNumber, convertToBase64, currencyFormat, hasPrice, hasYear, optText, driverLabel } from "../../constants/helper";
const ProductListRentCarItem = ({ val, i, loc, ...props }) => {
    const history = useHistory();
    const goToProductDetail = () => {
        history.push("/product_details/" + convertToBase64(val.id));
    }
    const manuName = optText(val.manufacturer_id == -1 ? val.manufacturer_name : (val.manufacturer && val.manufacturer.name));
    const modelName = optText(val.model_id == -1 ? val.model_name : (val.model && val.model.name));
    const title = [manuName, modelName, hasYear(val.year) ? val.year : ''].filter(Boolean).join(' ') || val.title;
    const colorValue = optText(val.color && val.color.color_value);
    const transmission = optText(val.transmission && val.transmission.name);
    const fuel = optText(val.fuel_type && val.fuel_type.fuel_name);
    const driver = driverLabel(val.is_driver);
    const seats = convertNumber(val.max_passengers) > 0 ? val.max_passengers : '';
    return (<div className="sectls cursor-pointer" key={i} onClick={goToProductDetail}>
        <Link to={"/product_details/" + convertToBase64(val.id)} className="sectls-img" onClick={(e) => e.stopPropagation()}>
            <img src={PREV_IMG + val.default_photo.img_path} alt={title} onError={(e) => { e.target.src = "/assets/images/placeholder.jpeg" }} />
        </Link>
        <div className="sectls-cont">
            <div className="sectls-ttl-wrap">
                <h3><Link to={"/product_details/" + convertToBase64(val.id)} onClick={(e) => e.stopPropagation()}>{title}
                    &nbsp;(Para alugar)</Link></h3>
            </div>
            {hasPrice(val.price) ? <div className="sectls-price-wrap">
                <p>Preço Diário</p>
                <p className="sectls-price">{currencyFormat(val.price)} {val.item_currency && val.item_currency.currency_symbol}</p>
            </div> : <div className="sectls-price-wrap"><ContactCta item={val} compact /></div>}
            {transmission &&
                <div className="sectls-qnt-wrap">
                    <p className="sectls-price"><FaCogs className="ic-rm4" />{transmission}</p>
                </div>}
            {fuel &&
                <div className="sectls-qnt-wrap">
                    <p>Tipo de combustível</p>
                    <p className="sectls-price mt-2"><FaGasPump className="ic-rm4" />{fuel}</p>
                </div>}
            {seats &&
                <div className="sectls-qnt-wrap">
                    <p className="sectls-price"><FaUsers className="ic-rm4" />{seats}</p>
                </div>}
            {driver &&
                <div className="sectls-qnt-wrap">
                    <p>Motorista</p>
                    <p className="sectls-price mt-2"><FaUserTie className="ic-rm4" />{driver}</p>
                </div>}
        </div>
        <div className="sectls-info">
            <div className="sectls-rating-wrap">
                <p className="sectls-rating">
                    Carregado
                </p>
                <p className="uploaded_txt">{val.added_date_str}</p>
            </div>
            {optText(val.phone_number) && <div className="sectls-rating-wrap">
                <p className="sectls-rating">
                    Tel
                </p>
                <p className="uploaded_txt">{val.phone_number}</p>
            </div>}
            {loc && loc.name && <div className="sectls-rating-wrap">
                <p className="sectls-rating">
                    Província
                </p>
                <p className="uploaded_txt">{loc.name}</p>
            </div>}
            <div className="sectls-rating-wrap">
                <p className="sectls-rating">
                    Tipo
                </p>
                <p className="uploaded_txt">Aluguer</p>
            </div>
            {colorValue &&
                <p className="sectls-id">Cor <span className="badge bg-primary bg-sn badge_pos"> {colorValue}</span></p>
            }
            {
                optText(val.description) &&
                <p className="sectls-id sectls-desc"><strong>Descrição:</strong> {val.description}</p>
            }
        </div>
    </div>);
}

export default ProductListRentCarItem;
